export default "__VITE_ASSET__3906cae2__"